import { all, call } from "redux-saga/effects";

// saga handlers
import userSaga from "./handlers/userHandlers";
import branchSaga from "./handlers/master/branchHandlers";
import dropdownSaga from "./handlers/dropdownHandlers";
import driverSaga from "./handlers/master/driverHandlers";
import bankSaga from "./handlers/master/bankHandlers";
import modeSaga from "./handlers/master/modeHandlers";
import departmentSaga from "./handlers/master/departmentHandlers";
import contentSaga from "./handlers/master/contentHandlers";
import packageTypeSaga from "./handlers/master/packageTypeHandlers";
import vehicleTypeSaga from "./handlers/master/vehicleTypeHandlers";
import vehicleSaga from "./handlers/master/vehicleHandlers";
import spinnerDataSaga from "./handlers/spinnerDataHandler";
import roleSaga from "./handlers/master/roleHandlers";
import leadSaga from "./handlers/sales/leadHandlers";
import pincodeSaga from "./handlers/master/pincodeHandlers";
import stateSaga from "./handlers/master/stateHandlers";
import districtSaga from "./handlers/master/districtHandlers";
import zoneSaga from "./handlers/master/zoneHandlers";
import areaCodeSaga from "./handlers/master/areaCodeHandlers";
import hubSaga from "./handlers/master/hubHandlers";
import activitySaga from "./handlers/sales/activityHandlers";
import customerSaga from "./handlers/master/customerHandlers";
import tatSaga from "./handlers/master/tatHandlers";
import rateSaga from "./handlers/master/rateHandlers";
import hrSaga from "./handlers/hr/hrHandlers";
import warehouseSaga from "./handlers/master/warehouseHandlers";
import permissionSaga from "./handlers/permissions/permissionHandlers";
import vendorSaga from "./handlers/master/vendorHandlers";
import vendorPincodeSaga from "./handlers/master/vendorPincodeHandlers";
import vasTypeSaga from "./handlers/master/vasTypeHandlers";
import vasRateSaga from "./handlers/master/vasRateHandlers";
import vasRuleSaga from "./handlers/master/vasRuleHandlers";
import valueAddedServiceSaga from "./handlers/master/valueAddedServiceHandlers";
import customerRateSaga from "./handlers/master/customerRateHandlers";
import customerVasSaga from "./handlers/master/customerVasHandlers";
import billingSaga from "./handlers/master/billingHandlers";
import departmentPermissionSaga from "./handlers/permissions/departmentPermissionHandlers";
import pickupRequestSaga from "./handlers/operations/pickupRequestHandlers";
import departmentSectionSaga from "./handlers/permissions/departmentSectionHandlers";
import permissionRoleSaga from "./handlers/permissions/permissionRoleHandlers";
import sectionSaga from "./handlers/permissions/sectionHandlers";
import taSaga from "./handlers/master/taHandlers";
import dashboardPickupRequestSaga from "./handlers/operations/pickupRequestDashboardHandlers";
import pickupRequestSheetSaga from "./handlers/operations/pickupRequestSheetHandlers";
import myLeaveSaga from "./handlers/hr/myLeaveHandlers";
import salesReportSaga from "./handlers/sales/reportHandlers";
import salesExpenseSaga from "./handlers/sales/salesExpenseHandlers";
import customerUserSaga from "./handlers/customerUserHandlers";

// prettier-ignore
export default function* rootSaga() {
  yield all([
    call(userSaga),
    call(branchSaga),
    call(driverSaga),
    call(dropdownSaga),
    call(bankSaga),
    call(modeSaga),
    call(departmentSaga),
    call(contentSaga),
    call(packageTypeSaga),
    call(vehicleTypeSaga),
    call(vehicleSaga),
    call(spinnerDataSaga),
    call(roleSaga),
    call(leadSaga),
    call(pincodeSaga),
    call(stateSaga),
    call(districtSaga),
    call(zoneSaga),
    call(areaCodeSaga),
    call(hubSaga),
    call(activitySaga),
    call(customerSaga),
    call(customerUserSaga),
    call(tatSaga),
    call(rateSaga),
    call(hrSaga),
    call(permissionSaga),
    call(sectionSaga),
    call(vendorSaga),
    call(vendorPincodeSaga),
    call(vasTypeSaga),
    call(vasRateSaga),
    call(vasRuleSaga),
    call(valueAddedServiceSaga),
    call(customerRateSaga),
    call(customerVasSaga),
    call(billingSaga),
    call(departmentPermissionSaga),
    call(permissionRoleSaga),
    call(warehouseSaga),
    call(pickupRequestSaga),
    call(departmentSectionSaga),
    call(taSaga),
    call(dashboardPickupRequestSaga),
    call(pickupRequestSheetSaga),
    call(myLeaveSaga),
    call(salesReportSaga),
    call(salesExpenseSaga),
  ]);
}
